// extracted by mini-css-extract-plugin
module.exports = {"pg-lesson__filter":"styles_pg-lesson__filter__1GpoF","pg-lesson__filter__actions":"styles_pg-lesson__filter__actions__21SeA","pg-lesson__table":"styles_pg-lesson__table__2RAgj"};